import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import ExternalSiteDialog, { type ExternalSiteLink } from "./ExternalSiteDialog";

const linkedInSite: ExternalSiteLink = {
  label: "LinkedIn Aquaphys",
  url: "https://www.linkedin.com/company/aquaphys-water-energy-control/posts/?feedView=all",
  embeddable: false,
};

const Footer = () => {
  const { t } = useTranslation();
  const [linkedInOpen, setLinkedInOpen] = useState(false);

  return (
    <>
      <footer className="py-10 lg:py-16 border-t border-primary/20" role="contentinfo">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="space-y-3">
            <div>
              <span className="font-display text-xl text-foreground">Eaulistik</span>
              <p className="text-xs text-primary">by Aquaphys</p>
            </div>
            <p className="text-xs text-muted-foreground font-body">{t("footer.brandDesc")}</p>
            <div className="flex gap-2 text-xs text-muted-foreground font-body">
              <span>ANSES</span>·<span>Décret Tertiaire</span>·<span>Décret Bacs</span>
            </div>
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                onClick={() => setLinkedInOpen(true)}
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label="LinkedIn Aquaphys"
              >
                <Linkedin size={18} />
              </button>
            </div>
          </div>

          <nav aria-label="Footer navigation" className="space-y-3">
            <h3 className="font-display text-sm text-foreground">{t("footer.navigation")}</h3>
            {[
              { label: t("nav.solution"), href: "#solution" },
              { label: t("nav.benefits"), href: "#metrics" },
              { label: t("nav.clients"), href: "#social-proof" },
              { label: t("nav.about"), href: "#about" },
              { label: "FAQ", href: "#faq" },
            ].map((l) => (
              <a key={l.label} href={l.href} className="block text-sm text-muted-foreground font-body hover:text-foreground transition-colors">{l.label}</a>
            ))}
          </nav>

          <address className="space-y-3 not-italic">
            <h3 className="font-display text-sm text-foreground">{t("footer.contact")}</h3>
            <a href="mailto:service.client@aquaphys.com" className="block text-sm text-muted-foreground font-body hover:text-foreground transition-colors">service.client@aquaphys.com</a>
            <p className="text-sm text-muted-foreground font-body">AQUAPHYS<br />au Village By CA Paris<br />55, rue la Boétie<br />75008 Paris</p>
          </address>

          <div className="space-y-3">
            <h3 className="font-display text-sm text-foreground">{t("footer.legal")}</h3>
            <Link to="/mentions-legales" className="block text-sm text-muted-foreground font-body hover:text-foreground transition-colors">{t("footer.legalNotice")}</Link>
            <Link to="/politique-confidentialite" className="block text-sm text-muted-foreground font-body hover:text-foreground transition-colors">{t("footer.privacy")}</Link>
            <p className="text-xs text-muted-foreground font-body mt-4">© {new Date().getFullYear()} Aquaphys SAS. {t("footer.rights")}</p>
          </div>
        </div>
      </footer>

      <ExternalSiteDialog open={linkedInOpen} onOpenChange={setLinkedInOpen} site={linkedInSite} />
    </>
  );
};

export default Footer;
